import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Controller, useForm } from "react-hook-form";
import ClipLoader from "react-spinners/ClipLoader";
import {analyticsEvents, bgItemTypes, jobContracts,} from "../../../db/models/const";
import {professionScopes} from "../../../db/datasets/professions";
import {closeDialog} from "../../../slices/dialog";
import {selectUid} from "../../../slices/auth";
import {updateStudentBgItem} from "../../../api/common";
import "../../CommonComponents.scss";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useTranslation } from "react-i18next";
import TextEditor from "../../../common/components/TextEditor/main";

export const EditCvJob = ({ job }) => {
    const { t } = useTranslation();
    const { register, handleSubmit, control, errors } = useForm({
        defaultValues: {
            label: job?.label || "",
            place: job?.place || "",
            scope: professionScopes[job?.scopeId || 0],
            contractId: job?.contractId || 0,
            begin: job?.begin ? new Date(job?.begin.seconds * 1000) : null,
            end: job?.end ? new Date(job?.end.seconds * 1000) : null
        },
    });
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const uid = useSelector(selectUid);
    const [description, setDescription] = useState(job?.description || "");

    const onSave = (form) => {
        const j = {
            ...job,
            scopeId: form.scope.id,
            label: form.label,
            contractId: form.contractId,
            begin: form.begin,
            end: form.end,
            description,
            place: form.place
        };

        setLoading(true);
        updateStudentBgItem(uid, bgItemTypes.JOB, j, job == null)
            .then(() => {
                setLoading(false);
                dispatch(closeDialog());
            })
            .catch((error) => setLoading(false));
    };

    return (
        <div className="bg-dialog">
            <form onSubmit={handleSubmit(onSave)}>
                <div className="element">
                    <div className="label">{t("student_job_scope_label")}</div>
                    <Controller
                        render={({ onChange, ...props }) => (
                            <Autocomplete
                                {...props}
                                options={professionScopes}
                                getOptionLabel={(option) => t(option.label)}
                                renderInput={(params) => <TextField {...params} />}
                                onChange={(e, x) => {
                                    onChange(x);
                                }}
                            />
                        )}
                        name={"scope"}
                        rules={{ required: true }}
                        control={control}
                    />
                    {errors.scope && <p>{t("student_job_scope_error")}</p>}
                </div>
                <div className="element">
                    <div className="label">{t("student_job_contract_label")}</div>
                    <Controller
                        render={({ onChange, ...props }) => (
                            <Select
                                fullWidth
                                {...props}
                                onChange={(e) => onChange(e.target.value)}
                            >
                                {jobContracts.map((x) => (
                                    <MenuItem key={x.id} value={x.id}>
                                        {t(x.label)}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}
                        name={"contractId"}
                        rules={{ required: true }}
                        control={control}
                    />
                    {errors.contractId && <p>{t("student_job_contract_error")}</p>}
                </div>
                <div className="element">
                    <div className="label">{t("student_job_label_label")}</div>
                    <input
                        type="text"
                        ref={register({ required: true })}
                        name="label"
                        placeholder={t("student_job_label_ph")}
                    ></input>
                    {errors.label && <p>{t("student_job_label_error")}</p>}
                </div>
                <div className="element">
                    <div className="label">{t("student_job_place_label")}</div>
                    <input
                        type="text"
                        name="place"
                        ref={register}
                        placeholder={t("student_job_place_ph")}
                    ></input>
                </div>
                <div className="element">
                    <div className="label">{t("student_job_begin_label")}</div>
                    <Controller
                        control={control}
                        name="begin"
                        rules={{ required: true }}
                        render={({ onChange, onBlur, value }) => (
                            <ReactDatePicker
                                onChange={onChange}
                                onBlur={onBlur}
                                selected={value}
                                dateFormat="MM/yyyy"
                                showMonthYearPicker
                            />
                        )}
                    />
                    {errors.begin && <p className="error">{t("student_job_begin_error")}</p>}
                </div>
                <div className="element">
                    <div className="label">{t("student_job_end_label")}</div>
                    <Controller
                        control={control}
                        name="end"
                        render={({ onChange, onBlur, value }) => (
                            <ReactDatePicker
                                onChange={onChange}
                                onBlur={onBlur}
                                selected={value}
                                dateFormat="MM/yyyy"
                                showMonthYearPicker
                            />
                        )}
                    />
                </div>
                <div className="element">
                    <div className="label">{t("student_job_desc_label")}</div>
                    <TextEditor
                        editorStyle={{minHeight: "150px"}}
                        placeholder={t("student_job_desc_ph")}
                        defaultValue={description}
                        HTMLvalueOnChangeCB={setDescription}/>
                </div>
                {!loading && <input type="submit" value={t("student_job_submit")}></input>}
                {loading && (
                    <div className="loader">
                        <ClipLoader size={20} color={"#7400b8"} loading={true} />
                    </div>
                )}
            </form>
        </div>
    );
}
